import { COLOR_KEYS } from '../../constants';
export const ctaCenteredConfig = {
    name: 'CTACentered',
    category: 'Zapier Sections',
    includeScrollTracking: true,
    image: 'https://cdn.zappy.app/9d8b75af83dac6849016e7b24b627558.svg',
    inputs: [
        {
            name: 'backgroundColor',
            type: 'string',
            enum: [
                COLOR_KEYS.neutral100,
                COLOR_KEYS.neutral800,
                COLOR_KEYS.moss,
                COLOR_KEYS.night,
                COLOR_KEYS.zapier,
                COLOR_KEYS.earth,
            ],
            defaultValue: COLOR_KEYS.neutral100,
        },
        {
            name: 'heading',
            type: 'string',
            required: true,
            defaultValue: 'Example heading',
        },
        {
            name: 'subHeading',
            type: 'string',
        },
        {
            name: 'description',
            type: 'richText',
        },
        {
            name: 'ctaText',
            type: 'string',
        },
        {
            name: 'ctaHref',
            type: 'string',
        },
        {
            name: 'ctaBtnColor',
            friendlyName: 'CTA button color',
            type: 'string',
            enum: ['primary', 'primary-alt', 'primary-dark', 'brand'],
        },
        {
            name: 'openInNewTab',
            helperText: 'Controls whether or not the CTA link opens in a new tab',
            type: 'boolean',
        },
        {
            name: 'maxWidth',
            type: 'number',
        },
    ],
};
//# sourceMappingURL=config.js.map